import lanaDaniel from '../assets/images/staff/lana-daniel.jpg';
import barinAhmed from '../assets/images/staff/barin-ahmed.jpg';
import sarmadMohammed from '../assets/images/staff/sarmad-mohammed.jpg';
import aryanAbdulkarim from '../assets/images/staff/aryan-abdulkarim.jpg';
import gulistanYusuf from '../assets/images/staff/gulistan-yusuf.jpg';
import diyarAbdulsalam from '../assets/images/staff/diyar-abdulsalam.jpg';
import aliAhmed from '../assets/images/staff/ali-ahmed.jpg';
import hendrinMohammed from '../assets/images/staff/hendrin-mohammed.jpg';

export const staffMembers = [
    {
        id: "001",
        name: {
            en: "Lana Daniel Isho",
            ar: "لانا دانيال ايشو ",
            ku: "لانا دانیال ایشو "
        },
        position: {
            en: "Institute Principal",
            ar: "مديرة المعهد",
            ku: "رێڤه‌به‌را په‌یمانگه‌هێ"
        },
        image: lanaDaniel,

    },
    {
        id: "002",
        name: {
            en: "Barin Ahmed Salih ",
            ar: "بارين احمد صالح ",
            ku: "بارین احمد صالح "
        },
        position: {
            en: "Vice Principal for Registration Affairs",
            ar: "معاون مدير لشؤون التسجيل",
            ku: "ه. ر. بو كاروبارێن تومارێ"
        },
        image: barinAhmed,

    },
    {
        id: "003",
        name: {
            en: "Sarmad M. Qaseem Sulaiman ",
            ar: "سرمد محمد قسيم سلمان ",
            ku: "سرمد محمدقسیم سلیمان "
        },
        position: {
            en: "Vice Principal for Administrative Affairs",
            ar: "معاون مدير للشؤون الإدارية",
            ku: "ه. ر. بو كاروبارێن كارگێری"
        },
        image: sarmadMohammed,

    },
    {
        id: "004",
        name: {
            en: "Aryan Abdulkarim Hassan ",
            ar: "آريان عبد الكريم حسن ",
            ku: "ئاریان عبدالكريم حسن "
        },
        position: {
            en: "Vice Principal for Student Affairs",
            ar: "معاون مدير لشؤون الطلاب",
            ku: "ه. ر. بو كاروبارێن قوتابییان"
        },
        image: aryanAbdulkarim,

    },
    {
        id: "005",
        name: {
            en: "Gulistan Yusuf Abdulkarim ",
            ar: "گلستان يوسف عبد الكريم ",
            ku: "گلستان یوسف عبدالكریم "
        },
        position: {
            en: "Vice Principal for Student Affairs",
            ar: "معاون مدير لشؤون الطلاب",
            ku: "ه. ر. بو كاروبارێن قوتابییان"
        },
        image: gulistanYusuf,

    },
    {
        id: "006",
        name: {
            en: "Diyar Abdulsalam Abdulhakim",
            ar: "ديار عبد السلام عبد الحكي",
            ku: "ديار عبدالسلام عبدالحكيم "
        },
        position: {
            en: "Vice Principal for Scientific Affairs - Management & Accounting Dept.",
            ar: "معاون مدير للشؤون العلمية - قسم الإدارة والمحاسبة",
            ku: "ه. ر. بو كاروبارێن زانستی - به‌شێ كارگێری و ژمێریاری"
        },
        image: diyarAbdulsalam,

    },
    {
        id: "007",
        name: {
            en: "Ali Ahmed Abubakar",
            ar: "علي احمد ابو بكر",
            ku: "علي احمد ابوبكر"
        },
        position: {
            en: "Vice Principal for Scientific Affairs - Computer Science Dept.",
            ar: "معاون مدير للشؤون العلمية - قسم علوم الحاسوب",
            ku: "ه. ر. بو كاروبارێن زانستی - به‌شێ زانستێن كومپیوته‌ری"
        },
        image: aliAhmed,

    },
    {
        id: "008",
        name: {
            en: "Hindreen M. Ameen Saleem",
            ar: "هندرين محمد امين سليم",
            ku: "هندرين محمدامين سليم"
        },
        position: {
            en: "Vice Principal for Scientific Affairs - Oil and Gas Science Dept.",
            ar: "معاون مدير للشؤون العلمية - قسم علوم النفط والغاز",
            ku: "ه. ر. بو كاروبارێن زانستی - به‌شێ زانستێن گاز و په‌ترول"
        },
        image: hendrinMohammed,

    }
];

export const getAllStaff = () => staffMembers;
